<template>
  <div class="m-l-50 m-t-30" v-loading="isLoading">
    <common-config class="fl m-r-20 bor-r-ccc w-600" :id="id" :form="form" :inputList="inputList" :isLimit="false">
      <template slot="self-config">
        <div class="export-config-left">
          <el-form-item label="允许用户选择导出列">
            <el-radio-group v-model="form.choose_column">
              <el-radio :label="1">允许</el-radio>
              <el-radio :label="0">不允许</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="导出内容">
            <el-radio-group v-model="form.export_type">
              <el-radio :label="10">同列表</el-radio>
              <el-radio :label="20">自定义配置</el-radio>
            </el-radio-group>
          </el-form-item>
          <list-table
            ref="listTable"
            style="width:550px;"
            :fields="inputList"
            :tableData="form.export_config.column"
            :isSimple="true"
            :hasImport="true"
            @addCol="addCol"
            @deleteCol="deleteCol"
            @setColConfig="setColConfig"
            @showImport="showImport"
            v-if="isSelfConfig"></list-table>
        </div>
      </template>
    </common-config>
    <div class="export-config-right">
      <col-config 
        class="fl"
        :col="currentCol"
        :fields="inputList"
        :tables="models"
        :isSimple="true"
        v-if="showColConfig && isShowRightList">
      </col-config>
    </div>
    <field-list
      ref="fieldList"
      :fields="inputList"
      @importFields="importFields">
    </field-list>
  </div>
</template>

<script>
  import http from '../../../../assets/js/http'
  import flowConfig from '../../../../config/flowConfig'
  import modelConfig from '../../../../config/modelConfig'
  import commonConfig from './commonConfig'
  import listTable from '../../classify/listTable.vue'
  import colConfig from '../../classify/colConfig.vue'
  import fieldList from './fieldList.vue'
  export default {
    data() {
      return {
        isLoading: false,
        id: 0,
        contentId: '',
        modelId: '',
        form: {
          name: '',  // 操作名
          rule_name: '', // 权限标识
          model_name: '',  // 所选模型
          choose_column: 0, // 允许用户选择列，1是0否
          export_type: 10, // 导出类型，10同列表20自定义配置
          export_config: {
            column: []
          }
        },
        inputList: [], // 控件
        models: [],
        currentCol: null,
        showColConfig: false
      }
    },
    methods: {
      async getModels() {
        let postData = {
          params: {
            status: 1
          }
        }
        let res = await this.apiGet('form/models', postData)
        let data = this.promiseHandler(data, res)
        this.models = data.list
      },
      async getInputList() {
        let postData = {
          params: {
            type: 1
          }
        }
        let res = await this.apiGet(`form/models/${this.modelId}/fields`, postData)
        let data = this.promiseHandler(data, res)
        let canExportData = []
        _(data).forEach((res) => {
          res.field = res.name
          if (this.canExport(res)) {
            canExportData.push(res)
          }
        })
        this.inputList = canExportData
      },
      getDetail() {
        this.isLoading = true
        this.apiGet(`cms/deals/${this.id}`).then((res) => {
          if (res.code == 200) {
            this.form.name = res.data.content_name
            this.form.rule_name = res.data.rule_name
            this.form.model_name = res.data.model_name
            if (res.data.config) {
              if (res.data.config.export_type) {
                this.form.export_type = res.data.config.export_type
              }
              if (res.data.config.export_config) {
                this.form.export_config = res.data.config.export_config
              }
              if (res.data.config.choose_column) {
                this.form.choose_column = res.data.config.choose_column
              }
            }
            this.modelId = res.data.model_id
            this.getInputList()
          } else {
            _g.dealError(this, res)
          }
          this.isLoading = false
        })
      },
      addCol(listIndex, obj) {
        obj = this.dealNewCol(obj)
        this.form.export_config.column.push(obj)
      },
      dealNewCol(obj) {
        delete obj.rule
        delete obj.deal_type
        delete obj.download_link
        delete obj.field_type
        delete obj.is_visible
        delete obj.key_config
        delete obj.link_option
        delete obj.width
        return obj
      },
      deleteCol(listIndex, index) {
        this.form.export_config.column.splice(index, 1)
        this.showColConfig = false
      },
      setColConfig(listIndex, index) {
        this.currentCol = this.form.export_config.column[index]
        this.showColConfig = true
      },
      showImport(value) {
        if (value) {
          this.$refs.fieldList.openDialog()
        } else {
          this.$refs.fieldList.openDialog()
        }
      },
      importFields(data) {
        _(data).forEach((res) => {
          let obj = this.$refs.listTable.sendColObj()
          obj.field_id = res.field_id
          obj.show_name = res.title
          this.addCol(null, obj)
        })
      },
      canExport(item) {
        return item.type != this.TYPE_FILE &&
               item.type != this.TYPE_PARAMS &&
               item.type != this.TYPE_MULTIRELATE &&
               item.type != this.TYPE_PHOTO &&
               item.type != this.TYPE_SUBRELATE
      },
      goback() {
        router.go(-1)
      }
    },
    computed: {
      showCondition() {
        return this.form.has_condition == 1
      },
      isSelfConfig() {
        return this.form.export_type == 20
      },
      isShowRightList() {
        if (this.form.export_type == 10) {
          this.showColConfig = false
        }
        return this.form.export_type == 20
      }
    },
    created() {
      this.id = parseInt(this.$route.params.id)
      this.contentId = parseInt(this.$route.params.contentId)
      this.getDetail()
      this.getModels()
    },
    components: {
      commonConfig,
      listTable,
      colConfig,
      fieldList
    },
    mixins: [http, modelConfig, flowConfig]
  }
</script>
<style scoped>
  /* .export-config-left{
    border: 1px solid;
    height:95% !important;
    overflow-y: scroll;
  } */
  .export-config-right{
    position: fixed;
    top: 90px;
    left: 900px;
    height: 650px;
    overflow-y: scroll;
  }
</style>


// WEBPACK FOOTER //
// exportConfig.vue?33f6d994